import RelatedArticlesContent from "./related-articles-content";
import { h, render } from "preact";

class SectionRelatedArticles extends HTMLElement {
  constructor() {
    super();
    this.data = scrapeSectionData(this);
    this.container = this.querySelector("[data-container]");
    render(<RelatedArticlesContent data={this.data} />, this.container);
  }
}

if (!customElements.get("section-related-articles")) {
  customElements.define("section-related-articles", SectionRelatedArticles);
}
